import { CREATE_LEAD_FAILURE, CREATE_LEAD_REQUEST, CREATE_LEAD_SUCCESS, DELETE_LEAD_FAILURE, DELETE_LEAD_REQUEST, DELETE_LEAD_SUCCESS, EDIT_LEAD_ALL_FAILURE, EDIT_LEAD_ALL_REQUEST, EDIT_LEAD_ALL_SUCCESS, EDIT_LEAD_FAILURE, EDIT_LEAD_REQUEST, EDIT_LEAD_SUCCESS } from "./actionsType";

export const createLeadRequest = (leadData, navigate) => ({
  type: CREATE_LEAD_REQUEST,
  payload: { leadData, navigate },
});

export const createLeadSuccess = (response) => ({
  type: CREATE_LEAD_SUCCESS,
  payload: response,
});

export const createLeadFailure = (error) => ({
  type: CREATE_LEAD_FAILURE,
  payload: error,
});


export const deleteLeads = data => ({
  type: DELETE_LEAD_REQUEST,
  payload: data,
});


// export const deleteLeads = (leadId,navigate) => (
//   {
//     type: DELETE_LEAD_REQUEST,
//     payload: { leadId, navigate },
//   });

export const deleteLeadSuccess = (response) => ({
  type: DELETE_LEAD_SUCCESS,
  payload: response,
});

export const deleteLeadFailure = (error) => ({
  type: DELETE_LEAD_FAILURE,
  payload: error,
});


export const editLeadRequest = (leadData, navigate) => ({
  type: EDIT_LEAD_REQUEST,
  payload: { leadData, navigate }
});

export const editLeadSuccess = (data) => ({
  type: EDIT_LEAD_SUCCESS,
  payload: data
});

export const editLeadFailure = (error) => ({
  type: EDIT_LEAD_FAILURE,
  payload: error
});



// edit all emplyee wise 
export const editLeadAllRequest = (leadData) => ({
  type: EDIT_LEAD_ALL_REQUEST,
  payload: { leadData}
});

export const editLeadAllSuccess = (data) => ({
  type: EDIT_LEAD_ALL_SUCCESS,
  payload: data
});

export const editLeadAllFailure = (error) => ({
  type: EDIT_LEAD_ALL_FAILURE,
  payload: error
});
